import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const companyfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {

  const formFields = [
    {
      type: 'divider',
      heading: 'Company Details',
      visible: true,
      span: 24,
    },
    {
      label: 'Name',
      key: 'name',
      type: 'text',
      placeholder: 'Enter the Company Name',
      visible: true,
      width: '25%',
      required: true,
    },
    {
      label: 'Legal ID',
      key: 'legal_id',
      type: 'text',
      placeholder: 'Enter the Legal ID',
      visible: true,
      width: '25%',
    },
    {
      label: 'Address',
      key: 'address',
      type: 'text',
      placeholder: 'Enter the Address',
      visible: true,
      width: '50%',
    },
    {
      label: 'Phone',
      key: 'phone',
      type: 'text',
      placeholder: 'Enter the Phone Number',
      visible: true,
      width: '25%',
    },
    {
      label: 'Email',
      key: 'email',
      type: 'text',
      placeholder: 'Enter the Email',
      visible: true,
      width: '25%',
    },
    {
      label: 'Website',
      key: 'website',
      type: 'text',
      placeholder: 'Enter the Website',
      visible: true,
      width: '25%',
    },
    {
      label: 'Logo',
      key: 'logo',
      type: 'text',
      placeholder: 'Enter the Logo URL',
      visible: true,
      width: '25%',
    },
    {
      type: 'divider',
      heading: 'Bank Details',
      visible: true,
      span: 24,
    },
    {
      label: 'Bank Number',
      key: 'bank_number',
      type: 'text',
      placeholder: 'Enter the Bank Number',
      visible: true,
      width: '25%',
    },
    {
      label: 'Bank Name',
      key: 'bank_name',
      type: 'text',
      placeholder: 'Enter the Bank Name',
      visible: true,
      width: '25%',
    },
    {
      label: 'Bank Branch',
      key: 'bank_branch',
      type: 'text',
      placeholder: 'Enter the Bank Branch',
      visible: true,
      width: '25%',
    },
  ];


  const CustomFields = response.CustomFields;

  if (CustomFields && CustomFields.length > 0) {
    CustomFields.forEach((field) => {
      formFields.push({
        label: field.name,
        key: 'cf.' + field.key,
        type: field.type,
        placeholder: field.placeholder,
        visible: true,
        width: '25%'
      });
    });
  }

  return formFields;
}

export const companyMobileCard = (item, index, getFieldValue) => {
  return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
    <View>
      <Text>TEST</Text>
      <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
    </View>
  </Card>;
}

export const companyMain = {
  fields: companyfields,
  mobileCard: null
}